<template>
  <BaseTemplate class="bg_white pb48">
    <div class="mv">
      <img :src="require('@/assets/images/keepgoing/header.png')" alt="">
    </div>
    <div class="mt24"></div>

    <!-- 達成前：選択完了（事前選択） -->
    <template v-if="!isAchieved">
      <div class="present_before_container pt32 pb24 pl16 pr16">
        <h1 class="present_before_title ab">プレゼント製品のご選択ありがとうございます</h1>
        <div class="present_before_text_box">
          <p class="present_before_text ab">ご選択いただいた製品は以下の通りです。</p>
          <p class="present_before_text ab mt16">12カ月間ご継続達成後、次回ご購入製品に同梱してお送りいたします。お楽しみにお待ちください。</p>
        </div>
        <div class="mt16"></div>
        <Product
          :product="selectedGiftProduct"
          :is-btn-show="false"
          :is-column="true"
        />
      </div>
    </template>

    <!-- 達成後：12カ月間ご継続ありがとうございます -->
    <template v-else>
      <div class="present_container pt32 pb24 pl16 pr16">
        <h1 class="present_title rb">12カ月間ご継続ありがとうございます</h1>
        <div class="">
          <img :src="require('@/assets/images/keepgoing/thanks-text.png')" alt="">
        </div>
        <div class="mt16"></div>
        <div class="text_container bg_white">
        <p class="present_text ab">プレゼントのご選択ありがとうございます。<br>ご選択いただいた製品は以下の通りとなります。<br>プレゼントは次回購入製品に同梱してお送りいたします。<br>お楽しみにお待ちください。</p>
        <div class="mt16"></div>
        <Product
          :product="selectedGiftProduct"
          :is-btn-show="false"
          :is-column="true"
        />
        <div class="mt16"></div>

        <p class="present_text ab">皆さまと末永くお付き合いいただくことこそ、私たちの願いです。<br>ナチュラリープラスは、何より”続けられる“ことを第一に考え、今後とも製品を継続してご購入していただいている皆さまに喜んでいただけるサービスを提供してまいります。<br>今後ともナチュラリープラスをよろしくお願いいたします。</p>
      </div>
      </div>
    </template>

    <div class="mt24"></div>
    <div class="btn_group">
      <BaseBtn :btnText="'プレゼントを選び直す'" :type="'blue'" @onClick="goPresent" class="mt16" />
      <BaseBtn :btnText="'スタンプカードに戻る'" :type="'blue'" @onClick="goStampCard" class="mt16" />
    </div>
  </BaseTemplate>
</template>

<script>
import BaseTemplate from "@/views/common/BaseTemplate.vue";
import BaseBtn from "@/components/common/BaseBtn.vue";
import BaseModal from "@/components/common/BaseModal.vue";
import Product from "@/components/keepgoing/Product.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BaseTemplate,
    BaseBtn,
    BaseModal,
    Product
  },
  methods: {
    ...mapActions("keepgoing", ["updateStampCount"]),
    goStampCard() {
      this.$router.push({ name: "KeepgoingIndex" });
    },
    goPresent() {
      this.$router.push({ name: "KeepgoingPresent" });
    },
  },
  computed: {
    ...mapGetters('keepgoing', ['selectedGiftProduct', 'stampCountFromApi']),
    /** アニメーション中の stampCount ではなく API 値で判定（チラつき防止） */
    isAchieved() {
      return this.stampCountFromApi >= 12;
    }
  },
  mounted() {
    this.updateStampCount();
  }
};
</script>

<style lang="css" scoped>
/* 達成後 */
.present_container {
  background-color: #F4D4DF;
}
.present_title {
  font-size: 20px;
  text-shadow: 1px 1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, -1px -1px 0 #fff;
  text-align: center;
}

.present_text {
  font-size: 14px;
  line-height: 1.5;
}

.text_container {
  border-radius: 8px;
  padding: 16px;
}

/* 達成前 */
.present_before_container {
  background-color: #FDF0F3;
}
.present_before_title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 16px;
}
.present_before_text_box {
  background-color: #FFFDE7;
  border-radius: 8px;
  padding: 16px;
}
.present_before_text {
  font-size: 14px;
  line-height: 1.6;
}

.product_container {
}
.product_list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}
.mt16 {
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/keepgoing/PresentComplete.vue